/* eslint-disable jsx-a11y/anchor-is-valid */
import { images } from "../../config/images";
import { useAppSelector } from "../../redux/Hooks/Hook";
import { useNavigate } from "react-router-dom";



const Header = () => {
  const navigate = useNavigate();

  const { UserRole } = useAppSelector(state => state.verifiedUser)
  const handleNavigate = () => {
    navigate("/")
  }
  return (

    <>
      {UserRole?.role?.name ?
        <></>
        :
        <nav className="navbar bg-white header-navbar">
          <div className="container-fluid">
            <a className="navbar-brand">
              <img src={images.powerplaylogo.default} alt="Powerplay" className="pe-auto" onClick={() => handleNavigate()} />
            </a>
          </div>
        </nav >
      }


    </>
  )
}

export { Header }